import { GridColDef } from '@material-ui/data-grid';

export const ColumnAno: GridColDef = {
  field: 'ano',
  headerName: 'Ano',
  width: 150,
  type: 'number',
};

export const ColumnConta: GridColDef = {
  field: 'cod_cta_i050',
  headerName: 'Conta',
  width: 120,
};

export const ColumnCentroCusto: GridColDef = {
  field: 'cod_ccusto_i100',
  headerName: 'Centro custo',
  width: 160,
};

export const ColumnJaneiro: GridColDef = {
  field: 'janeiro',
  headerName: 'Janeiro',
  width: 150,
  type: 'number',
};

export const ColumnFevereiro: GridColDef = {
  field: 'fevereiro',
  headerName: 'Fevereiro',
  width: 150,
  type: 'number',
};

export const ColumnMarco: GridColDef = {
  field: 'marco',
  headerName: 'Março',
  width: 150,
  type: 'number',
};

export const ColumnAbril: GridColDef = {
  field: 'abril',
  headerName: 'Abril',
  width: 150,
  type: 'number',
};

export const ColumnMaio: GridColDef = {
  field: 'maio',
  headerName: 'Maio',
  width: 150,
  type: 'number',
};

export const ColumnJunho: GridColDef = {
  field: 'junho',
  headerName: 'Junho',
  width: 150,
  type: 'number',
};

export const ColumnJulho: GridColDef = {
  field: 'julho',
  headerName: 'Julho',
  width: 150,
  type: 'number',
};

export const ColumnAgosto: GridColDef = {
  field: 'agosto',
  headerName: 'Agosto',
  width: 150,
  type: 'number',
};

export const ColumnSetembro: GridColDef = {
  field: 'setembro',
  headerName: 'Setembro',
  width: 150,
  type: 'number',
};

export const ColumnOutubro: GridColDef = {
  field: 'outubro',
  headerName: 'Outubro',
  width: 150,
  type: 'number',
};

export const ColumnNovembro: GridColDef = {
  field: 'novembro',
  headerName: 'Novembro',
  width: 150,
  type: 'number',
};

export const ColumnDezembro: GridColDef = {
  field: 'dezembro',
  headerName: 'Dezembro',
  width: 150,
  type: 'number',
};

export const ColumnObservacao: GridColDef = {
  field: 'observacao',
  headerName: 'obs',
  width: 400,
};

export const ColumnTipo: GridColDef = {
  field: 'tipo',
  headerName: 'Tipo',
  width: 250,
};

export const ColumnDemonstrativo: GridColDef = {
  field: 'id_tipo_dem_ger',
  headerName: 'Demonstrativo',
  width: 220,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};

export const ColumnId: GridColDef = {
  headerName: '#',
  field: 'id',
  hide: true,
  width: 400,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};
